module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {

	'use strict';
	
	fox.registerWidget('CrowdFunding', {
		
		configure: function () {

			this.registerOptions('', {
				widgets: {
					programsDl: {
						widget: 'Datalayer',
						method: 'funds.list',
						cacheChannel: 'funds'
					},
					banner: {
						widget: 'Widget',
						manualRender: true,
						template: 'crowdfunding_banner',
						embed: {
							widget: '@parent @parent',
							container: '.crowdfunding-wrapper'
						}
					},

					confirmPopup: {
						widget: 'Popup_Common',
						additionalClasses: 'mc-site-popup',
						'dialog.width': 385,
						'widgets.content.widget': 'CrowdFunding_Confirm'
					},
					errorPopup: {
						widget: 'Popup_Common',
						'dialog.width': 385,
						'widgets.content.template': 'popup_crowdfunding_payment_error'
					},
					successPopup: {
						widget: 'Popup_Common',
						'dialog.width': 385,
						'widgets.content.template': 'popup_crowdfunding_payment_success'
					},
				},

				handleWom: {
					dlLoaded: {
						widget: '#programsDl',
						event: 'loaded',
						callback: '_handleProgramsDlLoad'
					},
					inboxPaymentSelf: {
						widget: '@root #socket',
						event: [
							'inboxSocketEventFunds:billing:sale',
							'inboxSocketEventFunds:billing:action'
						],
						callback: '_handleSocketMessage'
					},
					paymentError: {
						widget: '#confirmPopup #content',
						event: 'prepareFailed',
						callback: '_handlePaymentError'
					},
					scroll: {
						widget: '#banner',
						event: 'addedToDom',
						callback: '_scrollToBlock'
					}
				},

				handleDom: {
					showConfirmationPopup: {
						targetWidget: '#banner',
						target: '.donate',
						event: 'click',
						callback: '_showConfirmationPopup'
					},
					share: {
						targetWidget: '#banner',
						target: 'a[data-share]',
						event: 'click',
						callback: '_share'
					}
				}
				
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.banner = this.wom1('#banner');

			this.dl = this.wom1('#programsDl');
			this.confirmPopup = this.wom1('#confirmPopup');
			this.confirmForm = this.confirmPopup.wom1('.CrowdFunding_Confirm');
			this.errorPopup = this.wom1('#errorPopup');
			this.successPopup = this.wom1('#successPopup');

			this.getPrograms();

			this.callParent('running', arguments);
		},

		activate: function () {
			this.getPrograms();
			this.callParent('activate', arguments);
		},

		getPrograms: function () {
			this.dl.load();
		},

        CrowdFunding: function (obj, dl, e) {
			var data = dl.getCollection()[0];
			if (data) {
				var progress = Math.ceil(fox.utils.getPercent(data.goalAmount, data.currentAmount));
				data.progress = progress > 100 ? 100 : progress;

				this.setData(data);
				this.bannerOptions(data);
				this.renderBanner();
				return;
			} else {
				this.banner._readyToRender = false;
			}
		},

		setData: function (data) {
			this.programData = data;
		},

		getData: function () {
			return this.programData;
		},

		bannerOptions: function (opts) {
			this.banner.setTemplateOptions(opts);
		},

		renderBanner: function () {
			this.banner.render();
		},

		_showConfirmationPopup: function (el) {
			var fundId = $(el).attr('data-fund-id');
			this.confirmForm.setFundId(fundId);
			this.showConfirmationPopup();
		},

		showConfirmationPopup: function () {
			this.confirmPopup.show();
		},

		showErrorPopup: function () {
			this.errorPopup.show();
		},

		showSuccessPopup: function () {
			if (!fox.site.member) {
				return;
			}

			this.successPopup.render();
			this.successPopup.wom1('#content')
				.setTemplateOptions({name: fox.site.member.getObjectValue('login')})
				.render();

			this.successPopup.show();
			this.dispatchEvent('showedSuccessPopup');
		},

		_handleSocketMessage: function (obj, s, e) {
			if (e.match('action')) {
				this.getPrograms();

				return;
			}
			if (obj.answer.amount > 0) {
				this.showSuccessPopup();
				console.warn('_handleSocketMessage', 'success', obj.amount);
			} else {
				console.warn('_handleSocketMessage', 'refund', obj.amount);
			}

			this.getPrograms();
		},

		_share: function (el) {
			var alias = $(el).attr('data-app-name');

			this.postToSocialNetwork(alias);
		},

		postToSocialNetwork: function (alias) {
			var params = {};

			switch(alias) {	
				case 'twitter':
					this.postToTwitter();
				break;

				case 'thumbler':
					this.postToTumblr();
				break;

				case 'email':
					this.showEmailDialog();
				break;
				case 'facebook':
					this.postToFB();
				return;
			}

			return;
		},

		postToFB: function () {
			var text = this.getPostContent();
			var shareLink = "https://www.facebook.com/dialog/feed?%20app_id=416606395129423%20&display=popup&link=" +
							this._getSignupUrl() +
							"&redirect_uri=http://facebook.com&description=" +
							text;
				//+ "&caption=Crowdfunding widget";

			window.open(shareLink, '', 'width=626,height=436');
		},

		postToTwitter: function () {
			var text = this.getPostContent();
			var shareLink = 'http://twitter.com/share?url=' +  this._getSignupUrl() + '&text=' + text;

			window.open(shareLink, '', 'width=626,height=436');
		},

		postToTumblr: function () {
			var text = this.getPostContent();
			var shareLink = 'http://tumblr.com/widgets/share/tool?canonicalUrl=' + this._getSignupUrl() + '&name=Nightwolf&caption=' + this.getPostContent();// + '&tags=modelcentro,model+centro,professional,website,model'
			
			window.open(shareLink, '', 'width=626,height=436');	
		},

		_getSignupUrl: function () {
			return [window.location.origin, 'sponsor'].join('/');//encodeURIComponent(fox.getEnv('design.domain') + '/sponsor');
		},

		getPostContent: function () {
			return 'Let\'s help send ' + fox.getEnv('screenName') + ' to Miami CamCon!';
		},

		_handlePaymentError: function (err) {
			this.showErrorPopup();
		},

		_scrollToBlock: function () {}

	}, 'Controller');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/crowdFunding.js
// module id = 865
// module chunks = 4